import { Alert, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useLocalization } from 'localization';
import { ESoftCountryCode } from 'constants/enums/general';
import { useCurrentBranch } from 'hooks/services/useCurrentBranch';

const Banner = () => {
  const { t } = useLocalization();

  const { clientStates } = useCurrentBranch();

  const isShow = clientStates?.currentSelectedBranch?.countryCode === ESoftCountryCode.DK;

  if (!isShow) return null;

  return (
    <Alert
      severity="warning"
      icon={<InfoIcon />}
      sx={{
        alignItems: 'center',
      }}
    >
      <Typography variant="body2">{t('common.messages.bannerText')}</Typography>
    </Alert>
  );
};

export default Banner;
